import { Translate } from '@hooks/useI18n';
import { translationKeys } from '@hooks/useQueryState/utils/getStatusOptions';

export const getTranslatedTerminationStatuses = (translate: Translate) => [
  translate(translationKeys.TERMINATED),
  translate(translationKeys.TERMINATED_AND_PAID),
];
